import bem from 'utils/bem';

export const block = bem('edit-clip-view-selector');
